import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  background: linear-gradient(45deg,#3569cf , white,white,#ff6b6b);
  text-align: center;
  height: 100vh;
  width: 100vw;
`